var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuScoresLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6607 7.23827L12.6567 10.3297L13.3668 14.702C13.4414 15.1622 13.2555 15.611 12.8807 15.8752C12.5232 16.1264 12.0651 16.1509 11.6832 15.9398L8.00006 13.8958L4.31619 15.9398C4.14388 16.036 3.95578 16.0827 3.76768 16.0827C3.5401 16.0827 3.31466 16.013 3.11866 15.8752C2.74388 15.6124 2.55722 15.1622 2.63189 14.702L3.34194 10.3297L0.337959 7.23826C0.0242209 6.91518 -0.0806037 6.44709 0.0637061 6.01488C0.204424 5.59632 0.556216 5.29549 0.982682 5.23017L5.11087 4.59693L6.96169 0.669841C7.15481 0.257742 7.55256 0 7.99984 0C8.4464 0 8.84487 0.257022 9.03799 0.670561L10.8888 4.59551L15.017 5.22874C15.4435 5.29407 15.7953 5.59489 15.936 6.01345C16.081 6.44494 15.9755 6.91376 15.6617 7.23684L15.6607 7.23827Z",
    fill: "#cccccc "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuScoresLocked);
export default __webpack_public_path__ + "static/media/course_menu_scores_locked.e88a922d675c176b3d658a0faa7ef3ca.svg";
export { ForwardRef as ReactComponent };